import React, { useEffect, useMemo } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import Home from './Home';
import { useShopify } from '../hooks';
import { useCollection } from '../context/collection';
import createTheme from '../theme/material-ui';
import NotFound from './NotFound';
import ProductLanding from './ProductLanding';
import Shirts from './Shirts';
import Hoodies from './Hoodies';
import Accessories from './Accessories';
import Youth from './Youth';
import BackgroundImages from './BackgroundImages';

const App = () => {
	const { createShop, createCheckout, fetchCollection } = useShopify();
	const { shopifyID, accentColor, accentColorLuminance } = useCollection();

	const theme = useMemo(() => createTheme(accentColor, accentColorLuminance), [
		accentColor,
		accentColorLuminance
	]);

	useEffect(() => {
		createShop();
		createCheckout();
		fetchCollection(shopifyID);
	}, [shopifyID]);

	return (
		<ThemeProvider theme={theme}>
			<div id="App">
				{/* <div className="bg-images-container">
					<img src="/././Assets/ChoopoStickman.png" alt="Choopo Logos Left" className="bg-image left" />
					<img src="/././Assets/ChoopoStickman.png" alt="Choopo Logos Right" className="bg-image right" />
				</div> */}
				<BackgroundImages />


				<Router>
					<Switch>
						<Route exact path="/" component={Home} />
						<Route exact path="/products" component={Home} />
						<Route exact path="/products/:id" component={ProductLanding} />
						<Route exact path="/latest" component={Home} />
						<Route exact path="/shirts" component={Shirts} />
						<Route exact path="/youth" component={Youth} />
						<Route exact path="/hoodies" component={Hoodies} />
						<Route exact path="/accessories" component={Accessories} />
						<Route exact path="*" component={NotFound} />
					</Switch>
				</Router>
			</div>
		</ThemeProvider>
	);
};


export default App;